import type { TimeJob } from '@/data/scheduleTimeTracking';

/** The record page of a job people clock in to: an installation, or a service ticket of either type. */
export const timeJobPath = (kind: TimeJob['kind'], id: string) => kind === 'installation' ? `/installations/${id}` : `/service/${id}`;
